import { render } from "./SavedScreen.vue?vue&type=template&id=7bd3add0&scoped=true"
import script from "./SavedScreen.vue?vue&type=script&lang=js"
export * from "./SavedScreen.vue?vue&type=script&lang=js"

import "./SavedScreen.vue?vue&type=style&index=0&id=7bd3add0&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7bd3add0"]])

export default __exports__